import { objectWithoutProperties as _objectWithoutProperties, toPropertyKey as _toPropertyKey, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { CLEAR_STATE, CHANGE_SELECTION, CHANGE_PAGINATION, CHANGE_FILTERS, RESET_LIST } from './actions.js';

var initialState = {};

var builders = function builders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case RESET_LIST:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, {
        filters: _objectSpread2({}, action.filters),
        pagination: _objectSpread2({}, action.pagination),
        selection: _objectSpread2({}, action.selection)
      }));

    case CHANGE_FILTERS:
      var newListState = _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        filters: action.filters
      });

      if (action.resetPage) {
        newListState.pagination = _objectSpread2(_objectSpread2({}, newListState.pagination), {}, {
          pageNumber: 1
        });
      }

      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, newListState));

    case CHANGE_PAGINATION:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        pagination: action.pagination
      })));

    case CHANGE_SELECTION:
      return _objectSpread2(_objectSpread2({}, state), {}, _defineProperty({}, action.id, _objectSpread2(_objectSpread2({}, state[action.id]), {}, {
        selection: action.selection
      })));

    case CLEAR_STATE:
      var _action$id = action.id;
      state[_action$id];

      var remainingState = _objectWithoutProperties(state, [_action$id].map(_toPropertyKey));

      return _objectSpread2({}, remainingState);

    default:
      return state;
  }
};

export { builders as default };
